import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import ResourceBox from './resource-box';
import useDetailsContext from '../../context';
import './resource-box.scss';
function CommonsHubBox() {
    const { communityResourceHeading: heading, communityResourceLogoUrl: logoUrl, communityResourceUrl: url, communityResourceCta: cta, communityResourceBlurb: blurb, communityResourceFeatureLinkUrl: featureUrl, communityResourceFeatureText: featureText } = useDetailsContext();
    if (!url) {
        return null;
    }
    return (React.createElement("div", { className: "resource-box double" },
        React.createElement("div", { className: "top-line" },
            React.createElement("h3", null, heading),
            React.createElement("img", { src: logoUrl, alt: "" })),
        React.createElement("div", { className: "blurb" },
            React.createElement(RawHTML, { Tag: "span", html: blurb }),
            React.createElement("br", null),
            React.createElement("a", { href: url },
                cta,
                " ",
                React.createElement(FontAwesomeIcon, { icon: faExternalLinkAlt }))),
        React.createElement("div", { className: "bottom" },
            React.createElement("div", { className: "right" }, featureUrl && React.createElement("a", { href: featureUrl }, featureText)))));
}
export default function ResourceBoxes({ models, includeCommonsHub = false }) {
    return (React.createElement(React.Fragment, null,
        includeCommonsHub && React.createElement(CommonsHubBox, null),
        models.map((model) => (React.createElement(ResourceBox, { model: model, key: model.heading })))));
}
